// @ts-strict-ignore
import { IOperation } from '@shared/undo/operation/i-operation';
import { BaseConnectionOperation } from './base-connection-operation';
import { Connection } from '@3d-scene/model3d/connection';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ConnectionCreator } from '@article/components/connections/connection-creation/connection-creator';
import { AdminService } from '../services/admin.service';
import { ProjectModel } from '@project/model/project.model';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { SceneManager } from '@3d-scene/manager/scene.manager';
import { ProjectArticleManager } from '@project/components/article/manager/project-article.manager';
import { ConnectionConverter } from '@article/components/connections/connection-creation/connection-converter';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { SelectionMetaElementUsageIdentity } from '@shared/vo/meta-element.vo';

export class RemoveConnectionOperation extends BaseConnectionOperation implements IOperation {

  private _detachedConnections: Connection[];

  constructor(
    adminService: AdminService,
    projectModel: ProjectModel,
    selectionModel: SelectionModel,
    selectionModelService: SelectionModelService,
    sceneManager: SceneManager,
    projectArticleManager: ProjectArticleManager,
    connectionCreator: ConnectionCreator,
    connectionConverter: ConnectionConverter,
    connection: Connection,
    articleContainer: ArticleContainer,
    article: ArticleVO,
    applicationRefreshService: ApplicationRefreshService) {
    super(
      adminService,
      projectModel,
      selectionModel,
      selectionModelService,
      sceneManager,
      projectArticleManager,
      connectionCreator,
      connectionConverter,
      connection,
      articleContainer,
      article,
      applicationRefreshService);
    this._detachedConnections = connectionCreator.getMultipurposeConnectionsBySelection(connection);
  }

  public getQualifiedClassName(): string {
    return 'RemoveConnectionOperation';
  }

  public getOperationDescription(): string {
    return 'removeConnectionOperation.description';
  }

  public async performRedo(): Promise<void> {
    this._detachedConnections = this.detachConnection(false);
  }

  public async performUndo(): Promise<void> {
    let mainConnection: Connection = null;
    this._detachedConnections.forEach((con: Connection) => {
      this._article.metaElements.push(con.metaElementVO);
      this._articleContainer.setConnection(con);
      this._articleContainer.model.add(con.mesh);
      if (mainConnection === null || con.isActive) {
        mainConnection = con;
      }
    });
    if (this._detachedConnections.length > 0) {
      this.notifyProjectChange();
      const connectionSelectionIdentity: SelectionMetaElementUsageIdentity = new SelectionMetaElementUsageIdentity(
        this._articleContainer.articleGUID,
        mainConnection
      );
      this.selectionModelService.selectObject(connectionSelectionIdentity, false, false);
    }
  }
}
